import React, { FC, useContext } from "react";
import AutoLayout from "@src/deprecatedDesignSystem/components/AutoLayout";
import {
  BuilderActionContext,
  redoAvailableCountAtom,
  undoAvailableCountAtom,
} from "@contexts/BuilderActionContext";
import { deprecatedTones } from "@src/deprecatedDesignSystem/styles/deprecatedColors";
import DeprecatedIcon, {
  DeprecatedIconType,
} from "@src/deprecatedDesignSystem/components/DeprecatedIcon";
import { useAtomValue } from "jotai";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui/tooltip";

const UndoRedoButtons: FC = () => {
  const builderActionContext = useContext(BuilderActionContext);
  const undoAvailableCount = useAtomValue(undoAvailableCountAtom);
  const redoAvailableCount = useAtomValue(redoAvailableCountAtom);
  return (
    <AutoLayout>
      <Tooltip>
        <TooltipTrigger asChild>
          <AutoLayout>
            <UndoRedoButton
              iconType={"undo"}
              disabled={!undoAvailableCount}
              onClick={() => {
                builderActionContext?.undoAction();
              }}
            />
          </AutoLayout>
        </TooltipTrigger>
        <TooltipContent side="bottom" hidden={!undoAvailableCount}>
          {`Undo (${undoAvailableCount || 0})`}
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <AutoLayout>
            <UndoRedoButton
              iconType={"redo"}
              disabled={!redoAvailableCount}
              onClick={() => {
                builderActionContext?.redoAction();
              }}
            />
          </AutoLayout>
        </TooltipTrigger>
        <TooltipContent side="bottom" hidden={!redoAvailableCount}>
          {`Redo (${redoAvailableCount || 0})`}
        </TooltipContent>
      </Tooltip>
    </AutoLayout>
  );
};

export default UndoRedoButtons;

type UndoRedoButtonProps = {
  iconType: DeprecatedIconType;
  disabled: boolean;
  onClick: () => void;
};

const UndoRedoButton: FC<UndoRedoButtonProps> = (props) => {
  return (
    <AutoLayout
      alignmentVertical={"center"}
      alignmentHorizontal={"center"}
      height={32}
      width={32}
      style={{
        borderRadius: 8,
        cursor: props.disabled ? "default" : "pointer",
      }}
      hoverStyle={
        props.disabled
          ? undefined
          : { backgroundColor: deprecatedTones.gray4Alpha }
      }
      onClick={props.disabled ? undefined : props.onClick}
    >
      <DeprecatedIcon
        type={props.iconType}
        color={props.disabled ? deprecatedTones.gray6 : deprecatedTones.gray12}
      />
    </AutoLayout>
  );
};
